// removed by extract-text-webpack-plugin
module.exports = {"root":"PaymentList__root___25tRa","item":"PaymentList__item___vznBn","cell":"PaymentList__cell___3Ybx9","label":"PaymentList__label___mQ_8H","value":"PaymentList__value___3A77s"};